import React, { useState, useEffect } from 'react';
import { connectSortBy } from 'react-instantsearch-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Item {
  key: string,
  value: string,
  sortKey?: string,
  wrapperClass?: string,
  sort?: {
    asc: string,
    desc: string,
  },
  requestSort?: (key: string) => void,
  getCurrentSort?: (key: string) => string,
}

interface Props {
  defaultRefinement: string,
  currentRefinement: string,
  items: Array<Item>,
  refine: (value: string) => void,
}

const TableHeaderSorter: React.FC<Props> = ({
  items,
  refine,
  currentRefinement,
  defaultRefinement,
}) => {
  const [currentSort, setCurrentSort] = useState(currentRefinement || defaultRefinement);

  useEffect(() => {
    if (currentRefinement) {
      if (currentRefinement !== currentSort) {
        setCurrentSort(currentRefinement);
      }
    }
  }, [currentRefinement, defaultRefinement]);
  const isJSON = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  return (
    <>
      {
        items.map((item: Item) => {
          const parsed = isJSON(item.value) && JSON.parse(item.value);
          if (parsed && Array.isArray(parsed)) {
            return (
              <th key={item.key} className="sort-wrapper align-middle p-0">
                <table className="sub-table sub-header">
                  <tbody>
                    <tr>
                      {parsed.map((itemInner: Item) => {
                        const {
                          getCurrentSort,
                          requestSort,
                        } = item;
                        const sortKey = itemInner?.sortKey || '';
                        const sortCallback = (e) => {
                          e.preventDefault();
                          if (requestSort) {
                            requestSort(sortKey);
                          }
                        };

                        return (
                          <th
                            key={itemInner.key}
                            className={`sort-wrapper align-middle border-0 ${itemInner?.wrapperClass || ''}`}
                          >
                            {
                              itemInner.value && (
                                <a
                                  className="btn text-table-header-text border-none d-flex container h-100 align-items-center p-0"
                                  href="#"
                                  onClick={sortCallback}
                                >
                                  <span>
                                    <p className="m-0 text-uppercase mr-1">{itemInner.value}</p>
                                  </span>
                                  <span
                                    className="d-flex flex-column justify-content-center align-items-center position-relative"
                                    style={{ width: '20px' }}
                                  >
                                    <FontAwesomeIcon
                                      size="xs"
                                      icon={faSortUp}
                                      color={getCurrentSort && getCurrentSort(sortKey) === 'asc' ? getComputedCSSVariable('black') : getComputedCSSVariable('table-header-text')}
                                    />
                                    <FontAwesomeIcon
                                      size="xs"
                                      icon={faSortDown}
                                      color={getCurrentSort && getCurrentSort(sortKey) === 'desc' ? getComputedCSSVariable('black') : getComputedCSSVariable('table-header-text')}
                                    />
                                  </span>
                                </a>
                              )
                            }
                          </th>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </th>
            );
          }
          const { sort } = item;
          if (!sort) {
            return (
              <th key={item.key} className="sort-wrapper align-middle">
                <p className="btn text-table-header-text border-none d-flex container h-100 align-items-center p-0 m-0">
                  <span className="m-0 mr-1 text-uppercase">
                    {item.value}
                  </span>
                </p>
              </th>
            );
          }
          const { asc, desc } = sort as { asc: string, desc: string };
          return (
            <th key={item.key} className="sort-wrapper align-middle">
              <a
                className="btn text-table-header-text border-none d-flex container h-100 align-items-center p-0"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (currentSort === asc) {
                    if (desc) {
                      setCurrentSort(desc);
                      refine(desc);
                    }
                  } else if (asc) {
                    setCurrentSort(asc);
                    refine(asc);
                  } else if (desc) {
                    setCurrentSort(desc);
                    refine(desc);
                  }
                }}
              >
                <span>
                  <p className="m-0 mr-1 text-uppercase">{item.value}</p>
                </span>
                <span className="d-flex flex-column justify-content-center align-items-center position-relative">
                  <FontAwesomeIcon
                    icon={faSortUp}
                    size="xs"
                    color={asc === currentSort ? getComputedCSSVariable('black') : getComputedCSSVariable('table-header-text')}
                    className={asc ? 'visible' : 'invisible'}
                  />
                  <FontAwesomeIcon
                    icon={faSortDown}
                    size="xs"
                    color={desc === currentSort ? getComputedCSSVariable('black') : getComputedCSSVariable('table-header-text')}
                    className={desc ? 'visible' : 'invisible'}
                  />
                </span>
              </a>
            </th>
          );
        })
      }
    </>
  );
};

export default connectSortBy(TableHeaderSorter);
